/**
 * « NUMÉRO MASQUÉ » (B3 du polish de scène) — un appelant qui masque son
 * numéro n'arrive pas vide : selon le maillon qui le signale, Twilio livre
 * un MARQUEUR à sa place, et le CRM l'affichait tel quel (« anonymous » dans
 * le journal, « +266696687 » dans l'historique).
 *
 * Les formes réellement observées :
 *   - `anonymous` / `restricted` / `unknown` (casse variable) — les marqueurs
 *     SIP transmis par Twilio quand l'opérateur masque l'appelant ;
 *   - `+266696687` — le « numéro » de repli de Twilio pour un appelant
 *     anonyme (il épelle ANONYMOUS sur un clavier téléphonique ; c'est aussi,
 *     par accident, un préfixe du Lesotho — d'où la comparaison EXACTE, pour
 *     ne jamais avaler un vrai numéro de là-bas plus long).
 *
 * Ce module est le classifieur PARTAGÉ : chaque surface d'affichage
 * (journal des appels, historique du composeur, fiche contact, overlay
 * d'entrant) l'interroge puis traduit dans SON namespace
 * (`telephony:call.withheldNumber`, `logs:common.withheldNumber`) — le module
 * reste pur, sans i18n, donc testable et importable de partout.
 *
 * ⚠️ Un numéro masqué ne se COMPOSE pas : les surfaces qui offrent
 * « rappeler » / « préremplir » / « SMS » doivent désactiver le geste, pas
 * seulement maquiller l'étiquette — composer `+266696687` appelle un numéro
 * qui n'existe pas.
 */

const WITHHELD_MARKERS = /^(anonymous|restricted|unknown)$/i

/** Numéro de repli Twilio d'un appelant anonyme — comparaison exacte. */
const TWILIO_ANONYMOUS_NUMBER = '+266696687'

/** Vrai si la valeur est un MARQUEUR d'appelant masqué, pas un numéro. */
export function isWithheldNumber(value: string | null | undefined): boolean {
  if (!value) return false
  const trimmed = value.trim()
  return WITHHELD_MARKERS.test(trimmed) || trimmed === TWILIO_ANONYMOUS_NUMBER
}
